export default __webpack_public_path__ + "static/speed-gauge-02-fb6d3b3d6963aaf2f6117ea496b5af76.png";